koUtil = require('resources/assets/coffee/Core/utils/knockout')

class exports.Prescription_Map extends KoModel

    constructor: (handler, data) ->
        super()

        @get_handler = ->
            return handler

        @get_original_data = ->
            return data

        @ignore [
            'rx_maps_on'
            'rx_maps_off'
            'multihybrid_on'
            'multihybrid_off'
        ]

        @transform (v, k) =>
            # multihybrid_rx_plan cannot be true if create_rx_maps is false
            if not @create_rx_maps()

                if k in [
                    'rx_map_min_pop'
                    'rx_map_max_pop'
                    'rx_map_max_num_pops'
                    'rx_map_min_pop_diff'
                    'rx_map_max_pop_diff'
                ]
                    return null

                else if k is 'multihybrid_rx_plan'
                    return false

            return v

        # rx maps toggle
        @create_rx_maps = ko.observable(data.create_rx_maps ? false)

        @rx_maps_on = ko.computed =>
            return @create_rx_maps() is true
        @rx_maps_off = ko.computed =>
            return @create_rx_maps() is false


        # population constraints

        # defaults
        # note: these should be the same as the ones in viewmodels/planting_rx/layer/Layer.coffee
        switch handler.parent.cropName
            when 'Soybeans'
                max_pop_limit = 400000
                default_min_pop = data.default_min_pop ? 150000
                default_max_pop = data.default_max_pop ? 250000
                default_min_pop_diff = data.company_min_pop_diff ? 500
                default_max_pop_diff = data.company_max_pop_diff ? 5000
            else # corn, corn silage, popcorn, whatever
                max_pop_limit = 60000
                default_min_pop = data.default_min_pop ? 20000
                default_max_pop = data.default_max_pop ? 40000
                default_min_pop_diff = data.company_min_pop_diff ? 100
                default_max_pop_diff = data.company_max_pop_diff ? 3000

        # pop range
        @rx_map_min_pop = ko.observable(null)
        @rx_map_max_pop = ko.observable(null)

        koUtil.constrainValues(0, @rx_map_min_pop)
        koUtil.constrainValues(@rx_map_min_pop, @rx_map_max_pop)
        koUtil.constrainValues(@rx_map_max_pop, max_pop_limit)

        @rx_map_min_pop(data.rx_map_min_pop ? default_min_pop)
        @rx_map_max_pop(data.rx_map_max_pop ? default_max_pop)

        # max # pops
        @rx_map_max_num_pops = ko.observable(data.rx_map_max_num_pops ? 20)

        # pop diff range
        @rx_map_min_pop_diff = ko.observable(null)
        @rx_map_max_pop_diff = ko.observable(null)

        koUtil.constrainValues(@rx_map_min_pop_diff, @rx_map_max_pop_diff)

        @rx_map_min_pop_diff(data.rx_map_min_pop_diff ? default_min_pop_diff)
        @rx_map_max_pop_diff(data.rx_map_max_pop_diff ? default_max_pop_diff)

        # rx plans toggle
        @multihybrid_rx_plan = ko.observable(data.multihybrid_rx_plan ? false)

        @multihybrid_on = ko.computed =>
            return @multihybrid_rx_plan() is true
        @multihybrid_off = ko.computed =>
            return @multihybrid_rx_plan() is false

        return this
